import { API_URL } from "./api.config";

export const api = {
  BASE_URL: API_URL,
  subscription: {
    GET_SUBSCRIPTIONS: "/ActiveMemberships",
  },
  main: {
    GET_CLUB_IMAGES: "/club-gallery",
    GET_HALLS_IMAGES: "/club/gallery",
  },
  halls: {
    GET_HALLS: "/getHalls",
    GET_HALL: (hallId: number, date: string) => `/getHall/${hallId}/${date}`,
  },
  profile: {
    auth: {
      LOGIN: "/auth/login",
      SIGNUP: "/auth/signup",
      CONFIRM: "/auth/confirm",
      RESTORE: "/auth/restore",
      CONFIRM_RESTORE: "/auth/confirm/restore",
      NEW_PASSWORD: "/auth/password/new",
    },
    registration: {
      REG: "/auth/signup",
    },
    settings: {
      changePass: {
        SEND_PHONE: "/auth/restore",
        SEND_CODE: "/auth/confirm/restore",
        SEND_NEW_PASSWORD: "/auth/password/new",
        CHANGE_PASS: "/user/reset",
        REQUEST_CODE: "/auth/restore",
      },
      getProfile: {
        DEL_PROFILE: (profileId: number) => `/profile/delete/${profileId}`,
        DELETE_USER: "/user",
        GET_PROFILE: "/user",
        GET_PROFILES: "/profile/profile",
        GET_TYPE: (type: string) => `/profile/create`,
        GET_TYPE_PROFILE: (profileId: number) => `/profile/update/${profileId}`,
        CREATE_PROFILE: "/profile/create",
        UPDATE_PROFILE: (profileId: number) => `/profile/update/${profileId}`,
      },
      changeName: {
        CHANGE_NAME: "/user",
      },
      changeEmail: {
        GET_CODE_EMAIL: "/user",
        CHANGE_EMAIL: "/user",
      },
      changePhone: {
        CHANGE_PHONE: "/user/phone",
      },
    },
    cards: {
      ADD_CARD: "/cards",
      GET_CARD: "/cards",
      DELETE_CARD: "/cards/",
    },
    history: {
      GET_PURCHASE_HISTORY: "/profile/purchaseHistory",
    },
  },
  rent: {
    courts: {
      GET_COURTS: (date: string) => `/arena/${date}/new`,
    },
    rackets: {
      GET_RACKETS: (date: string) => `/getRacketTime/${date}`,
    },
  },
  kassa: {
    GET_URL: (tokenData: string) =>
      `https://fitness.tennis.ru/payCardWeb/${tokenData}`,
  },
  payment: {
    // GET_PAYMENT_URL (виджет ЮKassa) удалён вместе с ЮKassa.
    CREATE_PAYMENT_LINKED_CARD: "/payment/cart",
    GET_PAYMENT_STATUS: (paymentId: string) => `/payment/status/${paymentId}`,
  },
  cart: {
    ADD_RESERVE: "/cart/add",
    DELETE_FROM_CART: "/cart/delete",
  },
  feedback: {
    FEEDBACK: "/email/feedback",
    BOT: "/email/bot",
  },
  school: {
    TENNIS_SCHOOL: "/personalChildTrainingOrder",
    PERSONAL_TRAINING: "/personalTrainingOrder",
  },
  news: {
    GET_NEWS: (limit: number) => `/news/${limit}`,
  },
  contacts: {
    GET_CONTACTS: "/club/contacts",
  },
  club: {
    CONTACTS: "/club/contacts",
    GALLERY: "/club/gallery",
    GALLERY_MAIN: "/club-gallery",
    POLICY: "/club/policy",
    RULE: "/club/rule",
    NOTICES: "/club/notices",
  },
  frontendLog: {
    CREATE_LOG: "/frontend-log",
    GET_LOGS: (limit?: number) => limit ? `/frontend-log?limit=${limit}` : "/frontend-log",
  },
  token: {
    CHECK: "/token/check",
  },
  bitrix: {
    CREATE_MODIFY_PARTNER: "/CreateModifyPartner",
    PARTNER_LOOKUP: "/partner/lookup",
    GET_ACTIVE_MEMBERSHIPS: "/ActiveMemberships",
    GET_AFFORDABLE_GIFTS: (partnerId: string) => `/AffordableGifts/${partnerId}`,
    ACTIVATE_GIFT: "/ActivateGift/",
    GET_DAILY_SCHEDULE: (partnerId: string, date: string) => `/DailySchedule/${partnerId}/${encodeURIComponent(date)}`,
    GET_ACTIVE_COURTS: "/ActiveCourts",
    CREATE_CANCEL_RENT: "/CreateCancelRent",
    GET_PURCHASE_HISTORY: (partnerId: string, startDate?: string) => {
      const date = startDate || '2021-01-01T00:00:00';
      return `/PurchaseHistory/${partnerId}/p?startDate=${encodeURIComponent(date)}`;
    },
    GET_SOLD_MEMBERSHIPS: (partnerId: string) => `/SoldMemberships/${partnerId}`,
    GET_FAMILY_PURCHASE_HISTORY: "/FamilyPurchaseHistory",
    WAITING_PAYMENT: "/WaitingPayment",
    CREATE_PAYMENT: "/CreatePayment",
  },
};
